import React from 'react';

const GenderFilter = ({ selectedGender, onGenderChange }) => {
    // Using backend gender constants (single letters)
    const genders = [
        { id: 'M', emoji: '👨', label: 'For Him' },
        { id: 'F', emoji: '👩', label: 'For Her' },
        { id: 'U', emoji: '👥', label: 'For Everyone' }
    ];

    return (
        <div>
            <h3 className="font-medium text-accent-800 mb-3 flex items-center">
                👤 Gift For
            </h3>

            <div className="grid grid-cols-3 gap-2">
                {genders.map((gender) => (
                    <button
                        key={gender.id}
                        onClick={() => onGenderChange(gender.id)}
                        className={`p-2 rounded-lg text-center transition-all duration-200 ${selectedGender === gender.id
                            ? 'border-2 border-purple-600 bg-purple-200 shadow-inner transform scale-95'
                            : 'border-2 border-accent-200 hover:border-accent-300 bg-white hover:bg-accent-50 shadow-sm'
                            }`}
                    >
                        <div className="text-lg mb-1">{gender.emoji}</div>
                        <div className={`text-xs ${selectedGender === gender.id
                            ? 'font-bold text-purple-800'
                            : 'font-medium text-accent-600'
                            }`}>
                            {gender.label}
                        </div>
                    </button>
                ))}
            </div>
        </div>
    );
};

export default GenderFilter; 